export default __webpack_public_path__ + "static/media/mas.949cdbbc.svg";